// @ts-ignore
import $ from 'jquery';

const debug = {
    dev: false,
    head: 'LAYOUT.NEW'
};

export default class LayoutNew {

    public $new     : any
    public isOpen   : boolean

    constructor() {

        if (debug.dev) console.log(debug.head, ".constructor");

        this.$new = null;

        this.isOpen = false;
    }

    toggle(value:any=null) {
        if (debug.dev) console.log(debug.head,"toggle newValue=", value);

        // if no value passed- toggle
        if (value==null) {
            value = !this.isOpen;
        }

        if (this.isOpen == value) return;

        // this.isOpen = value;

        if (value) this.open();
        else this.close();
    }

    open() {

        if (debug.dev) console.log(debug.head,"open");

        // if open already - do nothing
        if (this.isOpen ) {
            if (debug.dev) console.log(debug.head, "NEW ALREADY OPEN - DO NOTHING");
            return false;
        }

        if (!this.$new) this.$new = $("#ui-new-task");

        this.isOpen = true;

        this.$new.removeClass('hidden');

        gd.bus.triggerEvent('layout-new-toggle');
    }

    close() {

        if (debug.dev) console.log(debug.head,"close");

        // if open and same view mode - do nothing
        if (!this.isOpen) {
            if (debug.dev) console.log(debug.head, " ALREADY Closed - DO NOTHING");
            return false;
        }

        if (!this.$new) this.$new = $("#ui-new-task");

        this.isOpen = false;

        this.$new.addClass('hidden');

        gd.bus.triggerEvent('layout-new-toggle');
    }

}

// module.exports = LayoutNew;
